import React, { Component } from 'react'

//import components
import Grid from "../../../../components/grid";
import Portal from "../../../../components/portal";
import { AddLevel } from "./add-level/AddLevel";
import { connect } from "react-redux";
import { getCsrAssignmentSettings, addUpdateCsrAssignmentSettings } from "../../../../store/actions";
import './style.scss';
import Edit_icon from '../../../../assets/images/edit_icon.png'
import Delete_icon from '../../../../assets/images/delete_icon.png'
import { ConfirmationPopUp } from "../../../../components/confirmation";
import { sortBy } from 'lodash';
class CSRAssignmentsReport extends Component {

    state = {
        showLevelPopup: false,
        editData: {},
        enterpriseAcctEmployees: 75,
        isEditData: false,
        capacityLevels: [],
        columnDefs: [
            {
                headerName: "Level",
                field: "level",
                resizable: true,
                width: 150,
                flex: 1,

            },

            {
                headerName: "Max Employees",
                field: "maxEmployees",
                width: 110,
                flex: 1,


            },
            {
                headerName: "Max Accounts",
                field: "maxAccounts",
                resizable: true,
                width: 150,
                flex: 1,
            },
            {
                headerName: "Max Enterprise",
                field: "maxEnterprise",
                resizable: true,
                width: 150,
                flex: 1,
            },
            {
                headerName: "Action", field: "", sortable: false, filter: false, flex: 1,
                cellRendererFramework: (params) => (
                    <>
                        <div className="action">
                            <button className="btn btn-primary" onClick={() => this.editLevel({ ...params.data, rowIndex: params.rowIndex })} ><img src={Edit_icon} /></button>{" "}
                            <button className="btn btn-primary" onClick={() => this.toggleDeleteConfirmation(params.rowIndex)}><img src={Delete_icon} /></button>
                        </div>

                    </>)
            }
        ],
    };

    usersPayload = {};

    onGridReady = params => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        let dataSource = {
            getRows: async (params) => {
                this.gridApi.showLoadingOverlay();
                await this.props.getCsrAssignmentSettings(this.emailPayload);
                const { capacityLevels, enterpriseAcctEmployees } = this.props.CSRAssignmentReducer;
                this.setState({ enterpriseAcctEmployees: enterpriseAcctEmployees || 75, capacityLevels: sortBy(capacityLevels, "level") || [] })
                this.gridApi.hideOverlay();
                if (!capacityLevels?.length) {
                    this.gridApi.showNoRowsOverlay();
                }
                return params.successCallback(this.state.capacityLevels);
            }
        }
        params.api.setServerSideDatasource(dataSource);
    }


    editLevel = (params) => {
        this.setState({ showLevelPopup: true, editData: params, isEditData: true, })
    }

    toggleConfirmationPopup = () => {
        this.setState({ confirmationBox: false });
    };

    toggleDeleteConfirmation = (index) => {
        this.setState({ confirmationBox: true, index });
    };

    deleteLevel = async (index) => {
        let capLevels = this.state.capacityLevels;
        capLevels.splice(index, 1);
        await this.props.addUpdateCsrAssignmentSettings({ capacityLevels: capLevels });
        this.refreshGrid()
        this.setState({ confirmationBox: false })

    }

    toggleLevelPopup = () => {
        this.setState({ showLevelPopup: false })
    }

    saveSettings = async (e, field, data) => {
        e.preventDefault();
        await this.props.addUpdateCsrAssignmentSettings({ [field]: data });
        this.toggleLevelPopup()
        this.refreshGrid();
    }

    refreshGrid = () => {
        this.gridApi.refreshServerSide();
    }

    render() {
        let { showLevelPopup, confirmationBox, isEditData, columnDefs, editData, capacityLevels, index } = this.state
        return (
            <>

                <div className="table-header d-flex align-items-center justify-content-between">
                    <h2 className="page_title"> CSR Assignments </h2>
                </div>
                <div className="shadow_white_box full-box mt-0">

                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">

                        </div>
                        <div className="filter-field d-flex">
                            <button className="mla fs12 primary mini" onClick={() => this.setState({ showLevelPopup: true, isEditData: false })}>Add Level</button>
                        </div>

                    </div>
                    <div className="clients_grid">

                        <Grid
                            columnDefs={columnDefs}
                            rowModelType='serverSide'
                            onGridReady={this.onGridReady}
                            height='350px'
                        >
                        </Grid>

                        <div className="filter-field d-flex justify-content-between">

                            <div></div>
                            <div className="df acsa add_rate">
                                <p>Enterprise Account Employees Threshold</p>
                                <input type="number" value={this.state.enterpriseAcctEmployees}
                                    onChange={(e) => this.setState({ enterpriseAcctEmployees: e.target.value })}
                                    style={{ marginLeft: '15px' }}
                                />
                                <button className="mla fs12 primary mini" onClick={e => this.saveSettings(e, "enterpriseAcctEmployees", this.state.enterpriseAcctEmployees)} style={{ marginLeft: '15px' }}>Save</button>
                            </div>
                        </div>



                        {confirmationBox && (
                            <Portal
                                zIndex="101"
                                height="164px"
                                width="424px"
                                close={this.toggleConfirmationPopup}
                                title="Confirmation"
                            >
                                <ConfirmationPopUp
                                    message="Are you sure you want to delete this?"
                                    index={index}
                                    close={this.toggleConfirmationPopup}
                                    confirmation={() => this.deleteLevel(index)}
                                ></ConfirmationPopUp>
                            </Portal>
                        )}

                        {showLevelPopup && (
                            <Portal
                                zIndex="101"
                                height="440px"
                                width="320px"
                                close={this.toggleLevelPopup}
                                title={isEditData ? 'Edit Capacity Level' : 'Add Capacity Level'} >
                                <AddLevel
                                    close={this.toggleLevelPopup}
                                    level={isEditData ? editData.level : this.props.CSRAssignmentReducer.capacityLevels?.length + 1}
                                    rowData={editData}
                                    save={this.props.addUpdateCsrAssignmentSettings}
                                    isEditData={isEditData}
                                    refreshGrid={this.refreshGrid}
                                    capacityLevels={capacityLevels}
                                ></AddLevel>
                            </Portal>
                        )}
                    </div>

                </div>

            </>
        )
    }
}
const mapStateToProps = ({ UserReducer, WAGE, CSRAssignmentReducer }) => ({ UserReducer, WAGE, CSRAssignmentReducer });
export default connect(mapStateToProps, { getCsrAssignmentSettings, addUpdateCsrAssignmentSettings, addUpdateCsrAssignmentSettings })(CSRAssignmentsReport);
